'use strict';

export default class UserResource {
  constructor($q, $http, utils) {
    'ngInject';

    this.$q = $q;
    this.$http = $http;
    this.utils = utils;
  }

  findById(id) {
    return new this.$q((resolve, reject) => {
      this.$http.get(this.utils.getApiUrlV2(`users/${id}`))
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  }

  getLoginHisotry(id){
    return new this.$q((resolve, reject) => {
      this.$http.get(this.utils.getApiUrlV2(`users/${id}/login_history`))
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  }

  copyData(id, data){
    return new this.$q((resolve, reject) => {
      this.$http.get(this.utils.getApiUrlV2(`users/${id}/copy_data`))
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    })
  }

  getBraintreeToken(id){
    return new this.$q((resolve, reject) => {
      this.$http.get(this.utils.getApiUrlV2(`braintree/${id}/config`))
          .then(response => {
            resolve(response.data);
          })
          .catch(reject);
    });
  }

  processBraintreePayment(id, postData){
    return new this.$q((resolve, reject) => {
      this.$http.post(this.utils.getApiUrlV2(`braintree/${id}/check`), postData)
          .then(response => {
            resolve(response.data);
          })
          .catch(reject);
    });
  }
}



// WEBPACK FOOTER //
// ./app/src/resources/user.js